export interface LogoutOptions {
  logoutParams?: {
    returnTo?: string;
  };
}

export type LogoutCallback = (options?: LogoutOptions) => void;

let logoutCallback: LogoutCallback | null = null;

export const setLogoutCallback = (callback: LogoutCallback | null) => {
  logoutCallback = callback;
};

export const getLogoutCallback = (): LogoutCallback | null => logoutCallback;
